/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../api/graphql/API";

type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const adminQuerySymptomsTrackerDataTypesByUserSubIndex =
  /* GraphQL */ `query AdminQuerySymptomsTrackerDataTypesByUserSubIndex(
  $after: String
  $first: Int
  $user_sub: String!
) {
  adminQuerySymptomsTrackerDataTypesByUserSubIndex(
    after: $after
    first: $first
    user_sub: $user_sub
  ) {
    items {
      additional_data
      created_at
      day
      full_date
      id
      last_updated_at
      month
      symptoms_data
      user_sub
      user_sub_year
      user_sub_year_month
      year
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
    APITypes.AdminQuerySymptomsTrackerDataTypesByUserSubIndexQueryVariables,
    APITypes.AdminQuerySymptomsTrackerDataTypesByUserSubIndexQuery
  >;
export const adminQuerySymptomsTrackerDataTypesByUserSubYearIndex =
  /* GraphQL */ `query AdminQuerySymptomsTrackerDataTypesByUserSubYearIndex(
  $after: String
  $first: Int
  $user_sub: String!
  $year: String!
) {
  adminQuerySymptomsTrackerDataTypesByUserSubYearIndex(
    after: $after
    first: $first
    user_sub: $user_sub
    year: $year
  ) {
    items {
      additional_data
      created_at
      day
      full_date
      id
      last_updated_at
      month
      symptoms_data
      user_sub
      user_sub_year
      user_sub_year_month
      year
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
    APITypes.AdminQuerySymptomsTrackerDataTypesByUserSubYearIndexQueryVariables,
    APITypes.AdminQuerySymptomsTrackerDataTypesByUserSubYearIndexQuery
  >;
export const adminQuerySymptomsTrackerDataTypesByUserSubYearMonthIndex =
  /* GraphQL */ `query AdminQuerySymptomsTrackerDataTypesByUserSubYearMonthIndex(
  $after: String
  $first: Int
  $month: String!
  $user_sub: String!
  $year: String!
) {
  adminQuerySymptomsTrackerDataTypesByUserSubYearMonthIndex(
    after: $after
    first: $first
    month: $month
    user_sub: $user_sub
    year: $year
  ) {
    items {
      additional_data
      created_at
      day
      full_date
      id
      last_updated_at
      month
      symptoms_data
      user_sub
      user_sub_year
      user_sub_year_month
      year
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
    APITypes.AdminQuerySymptomsTrackerDataTypesByUserSubYearMonthIndexQueryVariables,
    APITypes.AdminQuerySymptomsTrackerDataTypesByUserSubYearMonthIndexQuery
  >;
export const getArticleVote = /* GraphQL */ `query GetArticleVote($id: ID!) {
  getArticleVote(id: $id) {
    additional_data
    created_at
    id
    reference
    user_sub
    vote
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetArticleVoteQueryVariables,
  APITypes.GetArticleVoteQuery
>;
export const getAskPCOSUser = /* GraphQL */ `query GetAskPCOSUser($id: ID!) {
  getAskPCOSUser(id: $id) {
    additional_data
    badges
    bookmarked_articles
    consent
    country
    created_at
    email
    firstname
    height
    id
    last_updated_at
    lastname
    pcos_diagnosed
    phone_number
    read_articles
    selected_questions_qpl
    self_assessment
    use_smart_goal
    user_sub
    weight
    weight_history
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAskPCOSUserQueryVariables,
  APITypes.GetAskPCOSUserQuery
>;
export const getCheckIn =
  /* GraphQL */ `query GetCheckIn($dateTime: AWSDateTime!, $goalId: String!) {
  getCheckIn(dateTime: $dateTime, goalId: $goalId) {
    dateTime
    feelingScale
    goalCompleted
    goalId
    id
    user_sub
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetCheckInQueryVariables,
    APITypes.GetCheckInQuery
  >;
export const getDecisionAidResponse =
  /* GraphQL */ `query GetDecisionAidResponse($id: ID!) {
  getDecisionAidResponse(id: $id) {
    id
    treatments {
      additional_data
      healthFactors {
        key
        value
        __typename
      }
      preQuestions {
        key
        value
        __typename
      }
      treatmentId
      treatmentOptions {
        additional_data
        optionId
        personalFitRating
        preferenceRank
        rating
        safetyPrecautions {
          key
          value
          __typename
        }
        userNote
        whatMattersResponses {
          key
          value
          __typename
        }
        __typename
      }
      whatElse {
        key
        value
        __typename
      }
      __typename
    }
    user_sub
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetDecisionAidResponseQueryVariables,
    APITypes.GetDecisionAidResponseQuery
  >;
export const getDiscussionMessage =
  /* GraphQL */ `query GetDiscussionMessage($created_at: AWSDateTime!, $id: ID!) {
  getDiscussionMessage(created_at: $created_at, id: $id) {
    additional_data
    approved
    created_at
    dislikes
    id
    last_updated_at
    likes
    message_content
    reference
    reply_message_delete_count
    reply_messages
    reply_messages_add_count
    s3_objects
    s3_objects_add_count
    s3_objects_delete_count
    user_sub
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetDiscussionMessageQueryVariables,
    APITypes.GetDiscussionMessageQuery
  >;
export const getDiscussionTopic =
  /* GraphQL */ `query GetDiscussionTopic($id: ID!) {
  getDiscussionTopic(id: $id) {
    addition_data
    approved
    content
    created_at
    id
    last_updated_at
    reference
    reply_message_add_count
    reply_message_delete_count
    user_sub
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetDiscussionTopicQueryVariables,
    APITypes.GetDiscussionTopicQuery
  >;
export const getGoal = /* GraphQL */ `query GetGoal($id: ID!) {
  getGoal(id: $id) {
    completed_goal
    forNoPeriods
    goalId
    id
    monthPeriod
    noTimesInPeriod
    obstacle
    response
    selectedSolution
    solutions
    startDate
    title
    user_sub
    yearPeriod
    __typename
  }
}
` as GeneratedQuery<APITypes.GetGoalQueryVariables, APITypes.GetGoalQuery>;
export const getHabit = /* GraphQL */ `query GetHabit($id: ID!) {
  getHabit(id: $id) {
    categoryId
    description
    iconName
    id
    user_sub
    __typename
  }
}
` as GeneratedQuery<APITypes.GetHabitQueryVariables, APITypes.GetHabitQuery>;
export const getHabitCategory =
  /* GraphQL */ `query GetHabitCategory($id: ID!) {
  getHabitCategory(id: $id) {
    defaultIconName
    id
    name
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetHabitCategoryQueryVariables,
    APITypes.GetHabitCategoryQuery
  >;
export const getQPL = /* GraphQL */ `query GetQPL($id: ID!) {
  getQPL(id: $id) {
    createdAt
    id
    isAnswered
    isCustom
    isOpenQuestion
    isPriority
    isQuestionsAndNotes
    question
    updatedAt
    user_sub
    __typename
  }
}
` as GeneratedQuery<APITypes.GetQPLQueryVariables, APITypes.GetQPLQuery>;
export const getSymptomsTrackerDataType =
  /* GraphQL */ `query GetSymptomsTrackerDataType($id: ID!) {
  getSymptomsTrackerDataType(id: $id) {
    additional_data
    created_at
    day
    full_date
    id
    last_updated_at
    month
    symptoms_data
    user_sub
    user_sub_year
    user_sub_year_month
    year
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetSymptomsTrackerDataTypeQueryVariables,
    APITypes.GetSymptomsTrackerDataTypeQuery
  >;
export const listArticleVotes = /* GraphQL */ `query ListArticleVotes(
  $filter: TableArticleVoteFilterInput
  $limit: Int
  $nextToken: String
) {
  listArticleVotes(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      additional_data
      created_at
      id
      reference
      user_sub
      vote
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListArticleVotesQueryVariables,
  APITypes.ListArticleVotesQuery
>;
export const listAskPCOSUsers = /* GraphQL */ `query ListAskPCOSUsers(
  $filter: TableAskPCOSUserFilterInput
  $limit: Int
  $nextToken: String
) {
  listAskPCOSUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      additional_data
      badges
      bookmarked_articles
      consent
      country
      created_at
      email
      firstname
      height
      id
      last_updated_at
      lastname
      pcos_diagnosed
      phone_number
      read_articles
      selected_questions_qpl
      self_assessment
      use_smart_goal
      user_sub
      weight
      weight_history
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAskPCOSUsersQueryVariables,
  APITypes.ListAskPCOSUsersQuery
>;
export const listCheckIns = /* GraphQL */ `query ListCheckIns(
  $filter: TableCheckInFilterInput
  $limit: Int
  $nextToken: String
) {
  listCheckIns(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      dateTime
      feelingScale
      goalCompleted
      goalId
      id
      user_sub
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCheckInsQueryVariables,
  APITypes.ListCheckInsQuery
>;
export const listDecisionAidResponses =
  /* GraphQL */ `query ListDecisionAidResponses(
  $filter: TableDecisionAidResponseFilterInput
  $limit: Int
  $nextToken: String
) {
  listDecisionAidResponses(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      treatments {
        additional_data
        healthFactors {
          key
          value
          __typename
        }
        preQuestions {
          key
          value
          __typename
        }
        treatmentId
        treatmentOptions {
          additional_data
          optionId
          personalFitRating
          preferenceRank
          rating
          safetyPrecautions {
            key
            value
            __typename
          }
          userNote
          whatMattersResponses {
            key
            value
            __typename
          }
          __typename
        }
        whatElse {
          key
          value
          __typename
        }
        __typename
      }
      user_sub
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
    APITypes.ListDecisionAidResponsesQueryVariables,
    APITypes.ListDecisionAidResponsesQuery
  >;
export const listDiscussionMessages =
  /* GraphQL */ `query ListDiscussionMessages(
  $filter: TableDiscussionMessageFilterInput
  $limit: Int
  $nextToken: String
) {
  listDiscussionMessages(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      additional_data
      approved
      created_at
      dislikes
      id
      last_updated_at
      likes
      message_content
      reference
      reply_message_delete_count
      reply_messages
      reply_messages_add_count
      s3_objects
      s3_objects_add_count
      s3_objects_delete_count
      user_sub
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
    APITypes.ListDiscussionMessagesQueryVariables,
    APITypes.ListDiscussionMessagesQuery
  >;
export const listDiscussionTopics = /* GraphQL */ `query ListDiscussionTopics(
  $filter: TableDiscussionTopicFilterInput
  $limit: Int
  $nextToken: String
) {
  listDiscussionTopics(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      addition_data
      approved
      content
      created_at
      id
      last_updated_at
      reference
      reply_message_add_count
      reply_message_delete_count
      user_sub
      __typename
    }
    nextToken
    scannedCount
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDiscussionTopicsQueryVariables,
  APITypes.ListDiscussionTopicsQuery
>;
export const listGoals = /* GraphQL */ `query ListGoals(
  $filter: TableGoalFilterInput
  $limit: Int
  $nextToken: String
) {
  listGoals(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      completed_goal
      forNoPeriods
      goalId
      id
      monthPeriod
      noTimesInPeriod
      obstacle
      response
      selectedSolution
      solutions
      startDate
      title
      user_sub
      yearPeriod
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ListGoalsQueryVariables, APITypes.ListGoalsQuery>;
export const listHabitCategories = /* GraphQL */ `query ListHabitCategories(
  $filter: TableHabitCategoryFilterInput
  $limit: Int
  $nextToken: String
) {
  listHabitCategories(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      defaultIconName
      id
      name
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListHabitCategoriesQueryVariables,
  APITypes.ListHabitCategoriesQuery
>;
export const listHabits = /* GraphQL */ `query ListHabits(
  $filter: TableHabitFilterInput
  $limit: Int
  $nextToken: String
) {
  listHabits(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      categoryId
      description
      iconName
      id
      user_sub
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListHabitsQueryVariables,
  APITypes.ListHabitsQuery
>;
export const listOrderedDiscussionTopics =
  /* GraphQL */ `query ListOrderedDiscussionTopics(
  $after: String
  $first: Int
  $reference: String!
) {
  listOrderedDiscussionTopics(
    after: $after
    first: $first
    reference: $reference
  ) {
    items {
      addition_data
      approved
      content
      created_at
      id
      last_updated_at
      reference
      reply_message_add_count
      reply_message_delete_count
      user_sub
      __typename
    }
    nextToken
    scannedCount
    __typename
  }
}
` as GeneratedQuery<
    APITypes.ListOrderedDiscussionTopicsQueryVariables,
    APITypes.ListOrderedDiscussionTopicsQuery
  >;
export const listQPLs =
  /* GraphQL */ `query ListQPLs($filter: TableQPLFilterInput, $limit: Int, $nextToken: String) {
  listQPLs(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      createdAt
      id
      isAnswered
      isCustom
      isOpenQuestion
      isPriority
      isQuestionsAndNotes
      question
      updatedAt
      user_sub
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ListQPLsQueryVariables, APITypes.ListQPLsQuery>;
export const listSymptomsTrackerDataTypes =
  /* GraphQL */ `query ListSymptomsTrackerDataTypes(
  $filter: TableSymptomsTrackerDataTypeFilterInput
  $limit: Int
  $nextToken: String
) {
  listSymptomsTrackerDataTypes(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      additional_data
      created_at
      day
      full_date
      id
      last_updated_at
      month
      symptoms_data
      user_sub
      user_sub_year
      user_sub_year_month
      year
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
    APITypes.ListSymptomsTrackerDataTypesQueryVariables,
    APITypes.ListSymptomsTrackerDataTypesQuery
  >;
export const queryArticleVotesByReferenceIndex =
  /* GraphQL */ `query QueryArticleVotesByReferenceIndex(
  $after: String
  $first: Int
  $reference: String!
) {
  queryArticleVotesByReferenceIndex(
    after: $after
    first: $first
    reference: $reference
  ) {
    items {
      additional_data
      created_at
      id
      reference
      user_sub
      vote
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
    APITypes.QueryArticleVotesByReferenceIndexQueryVariables,
    APITypes.QueryArticleVotesByReferenceIndexQuery
  >;
export const queryArticleVotesByUserSubIndex =
  /* GraphQL */ `query QueryArticleVotesByUserSubIndex(
  $after: String
  $first: Int
  $user_sub: String!
) {
  queryArticleVotesByUserSubIndex(
    after: $after
    first: $first
    user_sub: $user_sub
  ) {
    items {
      additional_data
      created_at
      id
      reference
      user_sub
      vote
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
    APITypes.QueryArticleVotesByUserSubIndexQueryVariables,
    APITypes.QueryArticleVotesByUserSubIndexQuery
  >;
export const queryAskPCOSUsersByUserSubIndex =
  /* GraphQL */ `query QueryAskPCOSUsersByUserSubIndex(
  $after: String
  $first: Int
  $user_sub: String!
) {
  queryAskPCOSUsersByUserSubIndex(
    after: $after
    first: $first
    user_sub: $user_sub
  ) {
    items {
      additional_data
      badges
      bookmarked_articles
      consent
      country
      created_at
      email
      firstname
      height
      id
      last_updated_at
      lastname
      pcos_diagnosed
      phone_number
      read_articles
      selected_questions_qpl
      self_assessment
      use_smart_goal
      user_sub
      weight
      weight_history
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
    APITypes.QueryAskPCOSUsersByUserSubIndexQueryVariables,
    APITypes.QueryAskPCOSUsersByUserSubIndexQuery
  >;
export const queryCheckInsByUserSub =
  /* GraphQL */ `query QueryCheckInsByUserSub($after: String, $first: Int, $user_sub: String!) {
  queryCheckInsByUserSub(after: $after, first: $first, user_sub: $user_sub) {
    items {
      dateTime
      feelingScale
      goalCompleted
      goalId
      id
      user_sub
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
    APITypes.QueryCheckInsByUserSubQueryVariables,
    APITypes.QueryCheckInsByUserSubQuery
  >;
export const queryDecisionAidResponsesByUserSub =
  /* GraphQL */ `query QueryDecisionAidResponsesByUserSub(
  $after: String
  $first: Int
  $user_sub: String!
) {
  queryDecisionAidResponsesByUserSub(
    after: $after
    first: $first
    user_sub: $user_sub
  ) {
    items {
      id
      treatments {
        additional_data
        healthFactors {
          key
          value
          __typename
        }
        preQuestions {
          key
          value
          __typename
        }
        treatmentId
        treatmentOptions {
          additional_data
          optionId
          personalFitRating
          preferenceRank
          rating
          safetyPrecautions {
            key
            value
            __typename
          }
          userNote
          whatMattersResponses {
            key
            value
            __typename
          }
          __typename
        }
        whatElse {
          key
          value
          __typename
        }
        __typename
      }
      user_sub
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
    APITypes.QueryDecisionAidResponsesByUserSubQueryVariables,
    APITypes.QueryDecisionAidResponsesByUserSubQuery
  >;
export const queryDiscussionMessagesByReferenceIndex =
  /* GraphQL */ `query QueryDiscussionMessagesByReferenceIndex(
  $after: String
  $first: Int
  $reference: String!
  $scanIndexForward: Boolean
) {
  queryDiscussionMessagesByReferenceIndex(
    after: $after
    first: $first
    reference: $reference
    scanIndexForward: $scanIndexForward
  ) {
    items {
      additional_data
      approved
      created_at
      dislikes
      id
      last_updated_at
      likes
      message_content
      reference
      reply_message_delete_count
      reply_messages
      reply_messages_add_count
      s3_objects
      s3_objects_add_count
      s3_objects_delete_count
      user_sub
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
    APITypes.QueryDiscussionMessagesByReferenceIndexQueryVariables,
    APITypes.QueryDiscussionMessagesByReferenceIndexQuery
  >;
export const queryDiscussionMessagesByUserSubIndex =
  /* GraphQL */ `query QueryDiscussionMessagesByUserSubIndex(
  $after: String
  $first: Int
  $scanIndexForward: Boolean
) {
  queryDiscussionMessagesByUserSubIndex(
    after: $after
    first: $first
    scanIndexForward: $scanIndexForward
  ) {
    items {
      additional_data
      approved
      created_at
      dislikes
      id
      last_updated_at
      likes
      message_content
      reference
      reply_message_delete_count
      reply_messages
      reply_messages_add_count
      s3_objects
      s3_objects_add_count
      s3_objects_delete_count
      user_sub
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
    APITypes.QueryDiscussionMessagesByUserSubIndexQueryVariables,
    APITypes.QueryDiscussionMessagesByUserSubIndexQuery
  >;
export const queryDiscussionTopicsByUserSubIndex =
  /* GraphQL */ `query QueryDiscussionTopicsByUserSubIndex($after: String, $first: Int) {
  queryDiscussionTopicsByUserSubIndex(after: $after, first: $first) {
    items {
      addition_data
      approved
      content
      created_at
      id
      last_updated_at
      reference
      reply_message_add_count
      reply_message_delete_count
      user_sub
      __typename
    }
    nextToken
    scannedCount
    __typename
  }
}
` as GeneratedQuery<
    APITypes.QueryDiscussionTopicsByUserSubIndexQueryVariables,
    APITypes.QueryDiscussionTopicsByUserSubIndexQuery
  >;
export const queryGoalsByUserSub =
  /* GraphQL */ `query QueryGoalsByUserSub($after: String, $first: Int, $user_sub: String!) {
  queryGoalsByUserSub(after: $after, first: $first, user_sub: $user_sub) {
    items {
      completed_goal
      forNoPeriods
      goalId
      id
      monthPeriod
      noTimesInPeriod
      obstacle
      response
      selectedSolution
      solutions
      startDate
      title
      user_sub
      yearPeriod
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
    APITypes.QueryGoalsByUserSubQueryVariables,
    APITypes.QueryGoalsByUserSubQuery
  >;
export const queryHabitsByUserSub =
  /* GraphQL */ `query QueryHabitsByUserSub($after: String, $first: Int, $user_sub: String!) {
  queryHabitsByUserSub(after: $after, first: $first, user_sub: $user_sub) {
    items {
      categoryId
      description
      iconName
      id
      user_sub
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
    APITypes.QueryHabitsByUserSubQueryVariables,
    APITypes.QueryHabitsByUserSubQuery
  >;
export const queryMetabolicHealthPdaByUserSub =
  /* GraphQL */ `query QueryMetabolicHealthPdaByUserSub($user_sub: String!) {
  queryMetabolicHealthPdaByUserSub(user_sub: $user_sub) {
    fbgTest {
      notes
      personalFitRating {
        affectingFactors
        hasRelevantFactors
        value
        __typename
      }
      rating
      reasonToChoose {
        earlyDiabetes
        simpleAndQuickTest
        __typename
      }
      reasonToDecline {
        cannotFast
        reliableTest
        __typename
      }
      __typename
    }
    hba1cTest {
      notes
      personalFitRating {
        affectingFactors
        hasRelevantFactors
        value
        __typename
      }
      rating
      reasonToChoose {
        cannotFast
        earlyDiabetes
        simpleAndQuickTest
        __typename
      }
      reasonToDecline {
        chronicIllness
        reliableTest
        __typename
      }
      __typename
    }
    id
    leastPreferred {
      id
      label
      __typename
    }
    mostPreferred {
      id
      label
      __typename
    }
    ogttTest {
      notes
      personalFitRating {
        affectingFactors
        hasRelevantFactors
        value
        __typename
      }
      rating
      reasonToChoose {
        reliableTest
        __typename
      }
      reasonToDecline {
        cannotDrinkSugarSolutions
        cannotFast
        doNotHaveTime
        __typename
      }
      __typename
    }
    user_sub
    whatElse {
      clearMostAffective
      confident
      enoughSupport
      understandBenefitsAndRisks
      __typename
    }
    whatMattersResponses {
      confidentInTheChoice
      enoughSupportAndAdvice
      understandBenefitsRisks
      yourBenefitsAndRisks
      __typename
    }
    whatMayAffect {
      accessAndCost
      age
      currentHealthConditions
      familyHistory
      lifestyleFactors
      pregnantOrPlanning
      previousTestResults
      symptoms
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
    APITypes.QueryMetabolicHealthPdaByUserSubQueryVariables,
    APITypes.QueryMetabolicHealthPdaByUserSubQuery
  >;
export const querySymptomsTrackerDataTypes =
  /* GraphQL */ `query QuerySymptomsTrackerDataTypes($after: String, $first: Int) {
  querySymptomsTrackerDataTypes(after: $after, first: $first) {
    items {
      additional_data
      created_at
      day
      full_date
      id
      last_updated_at
      month
      symptoms_data
      user_sub
      user_sub_year
      user_sub_year_month
      year
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
    APITypes.QuerySymptomsTrackerDataTypesQueryVariables,
    APITypes.QuerySymptomsTrackerDataTypesQuery
  >;
export const querySymptomsTrackerDataTypesByUserSubYearIndex =
  /* GraphQL */ `query QuerySymptomsTrackerDataTypesByUserSubYearIndex(
  $after: String
  $first: Int
  $year: String!
) {
  querySymptomsTrackerDataTypesByUserSubYearIndex(
    after: $after
    first: $first
    year: $year
  ) {
    items {
      additional_data
      created_at
      day
      full_date
      id
      last_updated_at
      month
      symptoms_data
      user_sub
      user_sub_year
      user_sub_year_month
      year
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
    APITypes.QuerySymptomsTrackerDataTypesByUserSubYearIndexQueryVariables,
    APITypes.QuerySymptomsTrackerDataTypesByUserSubYearIndexQuery
  >;
export const querySymptomsTrackerDataTypesByUserSubYearMonthIndex =
  /* GraphQL */ `query QuerySymptomsTrackerDataTypesByUserSubYearMonthIndex(
  $after: String
  $first: Int
  $month: String!
  $year: String!
) {
  querySymptomsTrackerDataTypesByUserSubYearMonthIndex(
    after: $after
    first: $first
    month: $month
    year: $year
  ) {
    items {
      additional_data
      created_at
      day
      full_date
      id
      last_updated_at
      month
      symptoms_data
      user_sub
      user_sub_year
      user_sub_year_month
      year
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
    APITypes.QuerySymptomsTrackerDataTypesByUserSubYearMonthIndexQueryVariables,
    APITypes.QuerySymptomsTrackerDataTypesByUserSubYearMonthIndexQuery
  >;
